import PropTypes from 'prop-types';
import TagPill from './TagPill';

import './TagList.less';

const TagList = (props) => {
  const { tags, onClick } = props;

  return <ul className="taglist">
    {tags.map((tag, idx) => <li key={`tag-${tag}`} className="taglist__item">
      <TagPill label={tag} index={idx} onClick={onClick}/>
    </li>)}
  </ul>;
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TagList;
